<template>
  <div>
    <v-combobox
      v-model="selected"
      :items="userDataMap"
      :loading="getAllUsersStatus"
      item-text="Description"
      item-value="id"
      :label="$t('settings.responsible')"
      :hint="$t('tickets.form.usersHint')"
      persistent-hint
      data-cy="users"
      multiple
      chips
      dense
      ><template v-slot:selection="data">
        <v-chip small close v-bind="data.attrs" @click:close="data.parent.selectItem(data.item)">
          {{ typeof data.item === "string" ? data.item : data.item.Description }}
        </v-chip>
      </template>
    </v-combobox>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["value"],
  data: () => ({}),
  mounted() {
    this.$store.dispatch("getUsers");
  },
  computed: {
    ...mapGetters(["getAllUsers", "getAllUsersStatus"]),
    userDataMap() {
      return this.getAllUsers.map((user) => {
        const Description = user.name + " - " + user.short;
        const id = user._id;
        return Object.assign({}, user, {
          Description,
          id,
        });
      });
    },
    selected: {
      get() {
        const ids = (this.value.users || []).map((u) => String((u && u._id) || u));
        const users = this.userDataMap.filter((u) => ids.includes(String(u.id)));
        return [...users, ...(this.value.externalUsers || [])];
      },
      set(list) {
        const users = [];
        const names = [];
        (list || []).forEach((item) => {
          if (typeof item === "string") {
            const name = item.trim();
            if (name && !names.includes(name)) names.push(name);
          } else if (item && item.id) {
            users.push(item.id);
          }
        });
        this.$set(this.value, "users", users);
        this.$set(this.value, "externalUsers", names);
      },
    },
  },
  methods: {},
};
</script>
